import axios from '@fs/zion-axios'
import { Chat } from '../../global/chatSettingsConfig'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

/* eslint-disable no-bitwise */
function hashCode(str) {
  let hash = 0
  let i
  let chr
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}
/* eslint-enable no-bitwise */

export const logSendMessage = ({ toJid, fromJid, jabberResource, fromDisplayName, message }) => {
  const messageLength = message.length
  const messageHash = hashCode(message).toString()

  const params = [
    `fromDisplayName=${fromDisplayName}`,
    `fromJid=${fromJid}`,
    `jabberResource=${jabberResource}`,
    `messageHash=${messageHash}`,
    `messageLength=${messageLength}`,
    `toJid=${toJid}`,
  ]

  return axios.post(`${serviceBaseUrl}/chat/log/send?${params.join('&')}`)
}

export const logChatHistoryTiming = ({ jabberResource, jid, duration }) => {
  const key = 'GetChatHistory'
  const params = [`jabberResource=${jabberResource}`, `jid=${jid}`, `key=${key}`, `value=${duration}`]

  return axios.post(`${serviceBaseUrl}/chat/log/metric?${params.join('&')}`)
}

export const logStartChatWithRelative = ({ jabberResource, jid, relativeJid }) => {
  const key = 'ChatWithRelative'
  const params = [`jabberResource=${jabberResource}`, `jid=${jid}`, `key=${key}`, `value=${relativeJid}`]

  return axios.post(`${serviceBaseUrl}/chat/log/metric?${params.join('&')}`)
}

export const logLogin = ({ jabberResource, jid, displayName }) => {
  const params = [`displayName=${displayName}`, `jid=${jid}`, `jabberResource=${jabberResource}`]
  return axios.post(`${serviceBaseUrl}/chat/log/login?${params.join('&')}`)
}

export const logMessageError = ({ jabberResource, jid1, jid2, displayName, errorName }) => {
  const params = [
    `jabberResource=${jabberResource}`,
    `jid1=${jid1}`,
    `jid2=${jid2}`,
    `displayName=${displayName}`,
    `error=${errorName}`,
  ]
  return axios.post(`${serviceBaseUrl}/chat/log/error?${params.join('&')}`)
}

export const logUnableToConnectError = ({ jabberResource, jid1, displayName, errorName }) => {
  const jid2 = Chat.Settings.DOMAIN
  return logMessageError({ jabberResource, jid1, jid2, displayName, errorName })
}

export const logAskUsAnythingMetric = ({ jabberResource, toJid, fromJid, displayName, topic }) => {
  const params = [
    `jabberResource=${jabberResource}`,
    `toJid=${toJid}`,
    `fromJid=${fromJid}`,
    `fromDisplayName=${encodeURIComponent(displayName)}`,
    `askUsAnythingTopic=${encodeURIComponent(topic)}`,
  ]
  return axios.post(`${serviceBaseUrl}/chat/log/askUsAnything?${params.join('&')}`)
}
